module.exports = __webpack_public_path__ + "img/ppt.dc2d3c5e.svg";